"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.core = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./account"), exports);
tslib_1.__exportStar(require("./avatar"), exports);
tslib_1.__exportStar(require("./bind"), exports);
tslib_1.__exportStar(require("./command"), exports);
tslib_1.__exportStar(require("./connection"), exports);
tslib_1.__exportStar(require("./disco"), exports);
tslib_1.__exportStar(require("./entity"), exports);
tslib_1.__exportStar(require("./features"), exports);
tslib_1.__exportStar(require("./hostmeta"), exports);
tslib_1.__exportStar(require("./jingle"), exports);
tslib_1.__exportStar(require("./mam"), exports);
tslib_1.__exportStar(require("./messaging"), exports);
tslib_1.__exportStar(require("./muc"), exports);
tslib_1.__exportStar(require("./pep"), exports);
tslib_1.__exportStar(require("./pubsub"), exports);
tslib_1.__exportStar(require("./roster"), exports);
tslib_1.__exportStar(require("./sasl"), exports);
tslib_1.__exportStar(require("./sharing"), exports);
const account_1 = tslib_1.__importDefault(require("./account"));
const avatar_1 = tslib_1.__importDefault(require("./avatar"));
const bind_1 = tslib_1.__importDefault(require("./bind"));
const command_1 = tslib_1.__importDefault(require("./command"));
const connection_1 = tslib_1.__importDefault(require("./connection"));
const disco_1 = tslib_1.__importDefault(require("./disco"));
const entity_1 = tslib_1.__importDefault(require("./entity"));
const features_1 = tslib_1.__importDefault(require("./features"));
const hostmeta_1 = tslib_1.__importDefault(require("./hostmeta"));
const jingle_1 = tslib_1.__importDefault(require("./jingle"));
const mam_1 = tslib_1.__importDefault(require("./mam"));
const messaging_1 = tslib_1.__importDefault(require("./messaging"));
const muc_1 = tslib_1.__importDefault(require("./muc"));
const pep_1 = tslib_1.__importDefault(require("./pep"));
const pubsub_1 = tslib_1.__importDefault(require("./pubsub"));
const roster_1 = tslib_1.__importDefault(require("./roster"));
const sasl_1 = tslib_1.__importDefault(require("./sasl"));
const sharing_1 = tslib_1.__importDefault(require("./sharing"));
function core(client) {
    client.use(features_1.default);
    client.use(disco_1.default);
    client.use(bind_1.default);
    client.use(connection_1.default);
    client.use(hostmeta_1.default);
    client.use(sasl_1.default);
}
exports.core = core;
function default_1(client) {
    client.use(account_1.default);
    client.use(messaging_1.default);
    client.use(avatar_1.default);
    client.use(command_1.default);
    client.use(entity_1.default);
    client.use(jingle_1.default);
    client.use(mam_1.default);
    client.use(muc_1.default);
    client.use(pep_1.default);
    client.use(pubsub_1.default);
    client.use(roster_1.default);
    client.use(sharing_1.default);
}
exports.default = default_1;
